<script>
/* Components */
import OldProductLegalText from './OldProductLegalText.vue';
import OldProductMarketingSummary from './OldProductMarketingSummary.vue';
import OldEmailSubscribe from './OldEmailSubscribe.vue';

export default {
  name: 'OldProductFootnote',
  components: {
    OldEmailSubscribe,
    OldProductLegalText,
    OldProductMarketingSummary,
  },
  props: {
    productHeaderDetails: {
      type: String,
      default: '',
    },
    showProductHeaderDetails: {
      type: Boolean,
      default: false,
    },
    productLegalText: {
      type: String,
      default: '',
    },
    showProductLegalText: {
      type: Boolean,
      default: false,
    },
    productMarketingSummary: {
      type: String,
      default: '',
    },
    showProductMarketingSummary: {
      type: Boolean,
      default: false,
    },
    partNumber: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div id="js__product__footnotes">
    <OldEmailSubscribe
      v-if="showProductHeaderDetails"
      :key="partNumber"
      :product-header-details="productHeaderDetails"
    />
    <OldProductLegalText
      v-if="showProductLegalText"
      :content="productLegalText"
    />
    <OldProductMarketingSummary
      v-if="showProductMarketingSummary"
      :content="productMarketingSummary"
    />
  </div>
</template>
